import { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { ExceptionErrorCode } from "../types/error/exception-error-code";

export interface OngBaseResponse<T> {
  data: T;
}

export interface OngBaseError {
  code: string;
  message: string;
  detail: { [key: string]: string };
}

export const getOngOngBaseResponse = (response: AxiosResponse) => {
  return response;
};

export const getOngOngBaseError = async (error: AxiosError) => {
  const baseError: any = error.response?.data;
  if (baseError) {
    if (Object.keys(ExceptionErrorCode).includes(baseError.code)) {
      return Promise.reject(error);
    }
    toast.error(baseError.error.message); // TODO 오류 메시지 처리
    return Promise.reject(error);
  }
  toast.error("오류가 발생했습니다. 관리자에게 문의하세요.");
  return Promise.reject(error);
};
